export const compareFileNames = (a, b) => {
    if (a && b) {
        a = a.replace("OSM", "").trim();
        b = b.replace("OSM", "").trim();

        const firstStep = a.localeCompare(b);
        return firstStep !== 0 ? firstStep : a.type.localeCompare(b.type);
    }
    return a.localeCompare(b);
}